import React, { useRef } from 'react'
import PropTypes from 'prop-types'
import SvgIcon from 'Components/SvgIcon'
import useOnClickOutside from 'Hooks/useOnClickOutside'
import useBodyOverflowHidden from 'Hooks/useBodyOverflowHidden'
import { _SearchPageMobileContainer, _Root, _Close, _Clear } from './styles'

/**
 * This component is simple wrapper component for search page mobile full height view
 * Currently, need to check scrollY to check whether header is hidden from scroll
 */
const SearchPageMobileContainer = ({
  children, onCloseClick, hideHeader, className = '',
  onClearClick, clearButtonEnable,
}) => {
  const container = useRef(null)
  useOnClickOutside(container, onCloseClick)
  useBodyOverflowHidden(true)

  return (
    <_SearchPageMobileContainer ref={container} hideHeader={hideHeader} className={className}>
      <_Root hideHeader={hideHeader}>
        <_Close hideHeader={hideHeader} onClick={onCloseClick}>
          <SvgIcon name={'#icon-arrow-final'} width={10} height={24} />
        </_Close>
        {
          clearButtonEnable ?
            <_Clear onClick={onClearClick}>
              Clear All
            </_Clear>
            : ''
        }
        {children}
      </_Root>
    </_SearchPageMobileContainer>
  )
}

SearchPageMobileContainer.propTypes = {
  onCloseClick: PropTypes.func,
  onClearClick: PropTypes.func,
  hideHeader: PropTypes.bool,
  className: PropTypes.string,
  children: PropTypes.oneOfType([PropTypes.node, PropTypes.arrayOf(PropTypes.node)]),
  clearButtonEnable: PropTypes.bool,
}
export default SearchPageMobileContainer
